<template>
  <div
    class="flex gap-1.5"
    :class="{
      'overflow-y-auto': viewport === 'mobile',
      'flex-wrap': viewport === 'desktop',
      'lg:flex-wrap max-lg:overflow-y-auto': viewport === 'reactive',
    }"
  >
    <Component
      v-for="item in items"
      :key="item.type"
      :is="item"
      :class="
        isMobile
          ? 'basis-[168px]'
          : items.length !== 3
          ? 'basis-1/3'
          : 'basis-1/6'
      "
    />
  </div>
</template>

<script setup>
import { computed, useSlots } from "vue";
import { useBreakpoints } from "@/Composables/useBreakpoints";

const props = defineProps({
  viewport: {
    type: String,
    validator: (val) => ["mobile", "desktop", "reactive"].includes(val),
    default: "reactive",
  },
});

const slots = useSlots();

const items = computed(() =>
  slots.default
    ? slots.default().reduce((items, slot) => {
        if (slot.props?.type) {
          items.push(slot);
        } else if (Array.isArray(slot.children) && slot.children.length) {
          slot.children.forEach((child) => {
            if (child.props?.type) {
              items.push(child);
            }
          });
        }
        return items;
      }, [])
    : []
);

const { maxTablet } = useBreakpoints();

const isMobile = computed(() => {
  switch (props.viewport) {
    case "mobile":
      return true;
    case "desktop":
      return false;
    case "reactive":
    default:
      return maxTablet.value;
  }
});
</script>
